import { AuthService } from '@abp/ng.core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { AppConstants } from 'src/app/app.constants';
import { ErrorService } from 'src/app/services/error.service';
import { AuthFacadeService } from './auth-facade.service';

@Injectable({
	providedIn: 'root'
})
export class StorageService
{
	/*
		Example usage:
		//save statistics
		await this.storageService.setItem(AppConstants.storageKeyStatistics, statistics);
		//get statistics
		const statistics = await this.storageService.getItem(AppConstants.storageKeyStatistics) as ReportStatistic[] || [];
	*/

	//We use a storage service so we can add other stuff on top of storage keys if we see fit
	constructor(
		private storage: Storage,
		private toastController: ToastController,
		private httpClient: HttpClient,
		private errorService: ErrorService
	)
	{
		this.initializeStorage();
	}

	async initializeStorage()
	{
		await this.storage.create().catch(() =>
		{
			this.toastController.create({
				message: 'Failed to initialize indexed db.',
				duration: 2000
			}).then(toast => toast.present());
		});
	}

	private formatKey(key: string)
	{
		const username = localStorage.getItem(AppConstants.storage_username);

		if (username) 
		{
			// Add username to key for logged in users to avoid data collision
			return `${username}_${key}`;
		}
		return `${key}`;
	}

	public setItem(key: string, value: any): Promise<any>
	{
		const formattedKey = this.formatKey(key);
		return this.storage.set(formattedKey, value);
	}

	public getItem(key: string): Promise<any>
	{
		const formattedKey = this.formatKey(key);
		return this.storage.get(formattedKey);
	}

	public clear(): Promise<void>
	{
		return this.storage.clear();
	}

	public remove(key: string): Promise<any>
	{
		const formattedKey = this.formatKey(key);
		return this.storage.remove(formattedKey);
	}
}
